/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-05-29 10:59:22
 * @LastEditTime: 2025-06-09 16:19:21
 */
/* eslint-disable */
/* tslint:disable */

import footerLogo from '../../images/footerLogo1.png'
import fwzx from '../../images/fwzx_qrcode.jpg'
import gxkf from '../../images/gxkf_qrcode.jpg'
import wxQr from '../../images/wx_qrcode.png'

import { Layout } from 'antd'

const Footer = () => {
  return (
    <Layout.Footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          {/*<div className="info-left">
            <div className="info-logo"></div>
            <div className="info-text">
              关于一些企业需求工艺开发， 自动化生产简洁等等，
              食品标准等等关于一些企业需求业需求工艺开发， 自动化生产简洁等等，
              食品标准业需工艺开发...
            </div>
          </div>*/}
          <div className="info-right">
            <div className="info-unit">
              <img src={footerLogo} />
            </div>
            <div
              className="info-nav"
              style={{
                marginLeft: '64px',
                minWidth: '545px',
                maxWidth: '600px',
              }}>
              <div className="top">
                赛组委会与知识产权服务机构、金融投资机构就本次大赛平台提供广泛的合作机会，诚邀相关单位共同参与，大赛合作意向及拟参赛单位未尽事宜可咨询组委会：
              </div>
              <div className="left" style={{ width: 'unset' }}>
                <div className="footer-title">联系人</div>
                <div
                  className="footer-subTitle"
                  style={{ paddingLeft: '20px' }}>
                  <span>司老师 18817392586</span>
                  <span style={{ marginLeft: '40px' }}>石老师 15202121208</span>
                  <span style={{ marginLeft: '40px' }}>
                    <a rel="nofollow" href="mailto:Marketing@stte.com">
                      Marketing@stte.com
                    </a>
                  </span>
                </div>
              </div>
              <div
                className="left"
                style={{ width: 'unset', marginTop: '0px' }}>
                <div className="footer-title">地址</div>
                <div
                  className="footer-subTitle"
                  style={{ paddingLeft: '20px' }}>
                  <span>上海市杨浦区国权北路1600号 B5-二楼</span>
                </div>
              </div>
            </div>

            <div className="info-nav link" style={{ flexWrap: 'nowrap' }}>
              <div className="right">
                {/* <div>
                  <img src={enQr} />
                  <p>合作意向请入</p>
                </div> */}
                <div>
                  <img src={wxQr} />
                  <p>上海技术交易所</p>
                </div>
                <div>
                  <img src={gxkf} />
                  <p>高校科技发展中心</p>
                </div>
                <div>
                  <img src={fwzx} />
                  <p>知识产权服务中心</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-text">
        Copyright ©2025 上技所数字科技（上海）有限公司 版权所有 ICP证：
        <a href="https://beian.miit.gov.cn/" target={'_blank'}>
          沪ICP备2023015760号-4
        </a>
        版本：1.0.0
      </div>
    </Layout.Footer>
  )
}

export default Footer
